import script from "./SlidePersonalizado.vue?vue&type=script&setup=true&lang=js"
export * from "./SlidePersonalizado.vue?vue&type=script&setup=true&lang=js"

import "./SlidePersonalizado.vue?vue&type=style&index=0&id=69dc6d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69dc6d5c"]])

export default __exports__